import { t } from '../../i18n.es.js';
import { styled, ButtonChevron } from '@teko/ui';
import React, { useState, useRef } from 'react';
import { getElementOffset } from '../../helpers/index.es.js';
import { getTrackingData } from '@teko/tracking';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const Content = styled.div(({ maxHeight, expanded }) => `
  background-color: #fff;
  max-height: ${maxHeight};
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
  position: relative;
  ${expanded ? "" : `
  &:after {
    content: ' ';
    background: linear-gradient(transparent, hsla(0, 0%, 100%, 0) 70%, #fff 90%);
    background-image: linear-gradient(rgba(255, 255, 255, 0), rgb(255, 255, 255));
    position: absolute;
    bottom: 0;
    height: 40px;
    width: 100%;
  }
  `}
`);
const Wrapper = styled.div`
  position: relative;
`;
const ShowMoreWrapper = styled.div``;
const StyledButtonChevron = styled(ButtonChevron)(({ theme }) => `
  border-radius: 0;
  justify-content: center;
  padding: 24px 0;
  color: ${theme == null ? void 0 : theme.brand.primary};
  width: calc(100% - 32px);
  margin-left: 16px;
  &:hover {
    color: ${theme == null ? void 0 : theme.brand.primary}
  }
  span {
    margin-left: 4px;
  }
`);
const HEADER_HEIGHT = 72;
const HEADING_HEIGHT = 56;
const ProductShortDescription = ({
  children,
  maxHeight,
  expandLabel,
  collapseLabel,
  moveTop = true,
  className,
  detailArticleScrollHeight
}) => {
  const [showMoreNeeded, setShowMoreNeeded] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const descriptionRef = useRef(null);
  const descriptionCallbackRef = (node) => {
    if (node && !showMoreNeeded) {
      descriptionRef.current = node;
      setShowMoreNeeded(node.clientHeight < (detailArticleScrollHeight || 0));
    }
  };
  const handleClick = () => {
    setExpanded((prev) => {
      if (prev && moveTop && descriptionRef && descriptionRef.current) {
        const element = descriptionRef.current;
        window.scrollTo({
          left: 0,
          top: getElementOffset(element).top - HEADER_HEIGHT - HEADING_HEIGHT
        });
      }
      return !prev;
    });
  };
  expandLabel = expandLabel || t("Xem th\xEAm");
  collapseLabel = collapseLabel || t("Thu g\u1ECDn");
  return /* @__PURE__ */ React.createElement(Wrapper, {
    className
  }, /* @__PURE__ */ React.createElement(Content, {
    ref: descriptionCallbackRef,
    maxHeight: expanded ? "fit-content" : `${maxHeight}px`,
    expanded
  }, children), showMoreNeeded && /* @__PURE__ */ React.createElement(ShowMoreWrapper, __spreadValues({}, getTrackingData({
    isTrackContent: true,
    regionName: "descriptionDetail",
    contentName: "viewMore"
  })), /* @__PURE__ */ React.createElement(StyledButtonChevron, {
    block: true,
    link: true,
    direction: expanded ? "up" : "down",
    onClick: handleClick
  }, expanded ? collapseLabel : expandLabel)));
};

export { ProductShortDescription };
